/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import Placeholder from 'flarum/common/components/Placeholder';
import type Mithril from 'mithril';

export default function () {
	extend(Placeholder.prototype, 'view', function (vdom) {
		(vdom.children as Mithril.Children[]).push(
			<div className="Placeholder-quotes">
				<span className="BCQuote opening" />
				<span className="BCQuote closing" />
			</div>
		);
	});
}
